import { Box, Link, Tooltip } from '@alice-financial/pretext-ui'
import CheckBoxIcon from '@mui/icons-material/CheckBox'
import CheckBoxOutlineBlankOutlinedIcon from '@mui/icons-material/CheckBoxOutlineBlankOutlined'
import IndeterminateCheckBoxOutlinedIcon from '@mui/icons-material/IndeterminateCheckBoxOutlined'
import WarningIcon from '@mui/icons-material/Warning'
import * as React from 'react'
import { HealthcheckRowData, HealthcheckStatus } from '../types'

interface HealthcheckStatusCellProps {
  row: HealthcheckRowData
}

const StatusIcon = ({ status, todo }: { status: HealthcheckRowData['status']; todo: boolean }) => {
  if (status === 'complete') return <CheckBoxIcon color="primary" />
  if (status === 'incomplete') {
    return todo ? <CheckBoxOutlineBlankOutlinedIcon color="primary" /> : <WarningIcon color="warning" />
  }
  if (status === 'pending' || status === 'partial') {
    return <IndeterminateCheckBoxOutlinedIcon color="primary" />
  }
  if (status === 'disabled') {
    return <IndeterminateCheckBoxOutlinedIcon color="disabled" />
  }
  return null
}

const LABELS: Record<HealthcheckStatus, string> = {
  complete: 'Done',
  incomplete: 'Incomplete',
  pending: 'Pending',
  partial: 'Partial',
  disabled: 'Not ready',
} as const

export const HealthcheckStatusCell = ({ row }: HealthcheckStatusCellProps) => {
  return (
    <Tooltip title={LABELS[row.status]} arrow placement="left">
      <Box
        component={row.navigationPath ? Link : 'div'}
        to={row.navigationPath ? row.navigationPath : undefined}
        sx={{
          textDecoration: 'none',
          cursor: row.navigationPath ? 'pointer' : 'default',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100%',
        }}
      >
        <StatusIcon status={row.status} todo={!row.org.isOnboarded} />
      </Box>
    </Tooltip>
  )
}
